import { render, staticRenderFns } from "./VendorProjectEdit.vue?vue&type=template&id=5b8b9244&"
import script from "./VendorProjectEdit.vue?vue&type=script&lang=js&"
export * from "./VendorProjectEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports